import { render } from "./my-orders.vue?vue&type=template&id=5133b05e&scoped=true"
import script from "./my-orders.vue?vue&type=script&lang=js"
export * from "./my-orders.vue?vue&type=script&lang=js"

import "./my-orders.vue?vue&type=style&index=0&id=5133b05e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5133b05e"]])

export default __exports__